<template>
<div>
  <b-input-group class="mb-3">
    <template #prepend>
      <b-input-group-text
        >Parameter 3 (colorbar)</b-input-group-text
      >
    </template>
    <b-form-input
      v-model="colorbarTitle"
      placeholder="Enter colorbar title"
      :disabled="!hasData"
      debounce="800"
    ></b-form-input>
  </b-input-group>

  <b-input-group class="mb-3">
    <template #prepend>
      <b-input-group-text>Colorbar Range</b-input-group-text>
    </template>
    <b-form-input
      type="number"
      v-model="colorbarRangeMin"
      :disabled="!hasData"
      placeholder="Min"
      debounce="800"
    ></b-form-input>
    <b-form-input
      type="number"
      v-model="colorbarRangeMax"
      :disabled="!hasData"
      placeholder="Max"
      debounce="800"
    ></b-form-input>
  </b-input-group>

  <b-input-group class="mb-3">
    <template #prepend>
      <b-input-group-text>Colorbar Theme</b-input-group-text>
    </template>
    <b-form-select
      id="colorbar-select"
      v-model="colorbarTheme"
      :options="colorbarChoices"
      :disabled="!hasData"
      debounce="800"
    >
    </b-form-select>
    <template #append>
      <b-card :class="barClass" no-body></b-card>
    </template>
  </b-input-group>
</div>
</template>
<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import colorscales from '@/components/CMOCEAN.json';

export default {
  props: ['chart', 'chartId', 'hasData', 'currentTrace'],
  methods: {
    ...mapActions('visualization/traces', [
      'updateTrace',
    ]),
  },
  computed: {
    // --------------------------------------------------------
    // Get/set for colorbar title
    colorbarTitle: {
      get() {
        return this.currentTrace.colorbar.title.text;
      },
      set(value) {
        const trace = { ...this.currentTrace };
        trace.colorbar.title.text = value;
        this.updateTrace({
          id: trace.id,
          updateObj: trace,
        });
      },
    },
    // Get/set for colorbar min
    colorbarRangeMin: {
      get() {
        return this.currentTrace.zmin;
      },
      set(value) {
        const trace = { ...this.currentTrace };
        trace.zmin = value;
        this.updateTrace({
          id: trace.id,
          updateObj: trace,
        });
      },
    },
    // Get/set for colorbar max
    colorbarRangeMax: {
      get() {
        return this.currentTrace.zmax;
      },
      set(value) {
        const trace = { ...this.currentTrace };
        trace.zmax = value;
        this.updateTrace({
          id: trace.id,
          updateObj: trace,
        });
      },
    },
    // Get/set for colorbar theme
    colorbarTheme: {
      get() {
        return this.currentTrace.selectedAxis.color.colorbar;
      },
      set(value) {
        const trace = { ...this.currentTrace };
        const colormap = colorscales[value];
        trace.selectedAxis.color.colorbar = value;
        trace.colorscale = colormap;
        this.updateTrace({
          id: trace.id,
          updateObj: trace,
        });
      },
    },
    barClass() {
      return `h-100 colorbar-colors ${this.colorbarTheme}`;
    },
    colorbarChoices() {
      const colorbarList = _.keys(colorscales);
      return colorbarList.map((val) => ({
        text: val,
        value: val,
      }));
    },
  },
};
</script>
<style>
.colorbar-colors {
  min-width: 150px !important;
}
.thermal {
  background: linear-gradient(
    to right,
    rgb(3.9667833995429036, 35.252282593483415, 51.46177604623678),
    rgb(18.873564708433232, 50.64156523304523, 113.53422502157348),
    rgb(73.20221438784256, 54.179630353385264, 159.28371024356304),
    rgb(115.65786637302985, 73.06091200273256, 146.41500300978396),
    rgb(154.32387640747461, 88.36149134908872, 136.9689351820826),
    rgb(197.63085871786257, 101.72828810672026, 119.1742487844456),
    rgb(234.5933859542238, 120.5075625653944, 87.63747737529172),
    rgb(251.14008799497, 157.91878161860828, 61.667170030613086),
    rgb(248.0853098343754, 203.0387801120806, 67.17368057344709),
    rgb(231.80566962518793, 250.450138612026, 90.65449063963804)
  );
  background-repeat: no-repeat;
}
.haline {
  background: linear-gradient(
    to right,
    rgb(41.553003412010725, 24.28005873490703, 107.7560958148976),
    rgb(37.138903238485575, 44.50497946642615, 162.8605330109369),
    rgb(12.208240212608644, 83.18051173360976, 147.68391004421872),
    rgb(31.977483065522705, 109.95567121162365, 138.67189999704667),
    rgb(51.759424692205506, 133.93331627058967, 136.28080181863936),
    rgb(67.2819882455002, 159.84853963503437, 132.47598166990159),
    rgb(89.50798359362147, 185.27474433334945, 120.06315538995962),
    rgb(136.67934688087553, 208.28483800371586, 96.74971650780321),
    rgb(202.0563209805993, 222.71410596129633, 104.85153437439057),
    rgb(253.49054803003938, 238.8655333884997, 153.68084905623283)
  );
  background-repeat: no-repeat;
}
.solar {
  background: linear-gradient(
    to right,
    rgb(51.36340044476597, 19.713485061199627, 23.822161264409026),
    rgb(86.14297056026972, 30.569390693424058, 34.55925998661305),
    rgb(120.9051252487905, 40.66659022656687, 35.8551735019984),
    rgb(151.04874375697864, 59.24619363724781, 27.916437809439422),
    rgb(172.56352465535286, 85.14919499785412, 20.983493127349497),
    rgb(190.0427308219606, 115.16304028591053, 19.199757402744464),
    rgb(203.47150344891767, 146.13475714221298, 25.60747301349278),
    rgb(214.1938509427738, 180.2488372420938, 39.266946070094924),
    rgb(221.35886593490193, 215.45913064502892, 56.124110800750245),
    rgb(224.52954149176304, 253.46697030423755, 74.88008823338993)
  );
  background-repeat: no-repeat;
}
.ice {
  background: linear-gradient(
    to right,
    rgb(3.904476960636511, 5.742751441183806, 18.5458280265648),
    rgb(29.742069195308062, 29.081433769364825, 59.13032612379715),
    rgb(51.43019215575712, 50.346440898129245, 103.42747602971113),
    rgb(62.6637435392901, 75.47695483907094, 150.07511415921164),
    rgb(62.43183803027079, 106.20185148578827, 176.48884154421538),
    rgb(74.01453672693648, 137.9653102064432, 188.74763844617382),
    rgb(97.45050135019153, 167.67216364131534, 199.40565656814152),
    rgb(132.51515305391268, 198.00972759239932, 211.46079924536747),
    rgb(182.68154943905805, 224.78051389904206, 228.18648647256563),
    rgb(234.105120482072, 252.9124516503815, 253.17238027702751)
  );
  background-repeat: no-repeat;
}
.gray {
  background: linear-gradient(
    to right,
    rgb(0.00013053740289167238, 0.0005233288998937221, 0.0015255573749666492),
    rgb(21.67192382269842, 21.3399475675765, 21.275560698000003),
    rgb(48.03625202591796, 47.578320679994874, 47.39592787782459),
    rgb(74.15293525035652, 73.64965833996182, 73.3339446450999),
    rgb(99.58492079324715, 99.08694033678762, 98.63109376558887),
    rgb(126.91980463079491, 126.46091826223106, 125.84728289743131),
    rgb(154.84817226424454, 154.44849024079832, 153.6691231958653),
    rgb(185.95170358556422, 185.62615733923622, 184.65960393983144),
    rgb(218.70498232967753, 218.45484347563848, 217.29043711205765),
    rgb(254.86132988058, 254.68134219584223, 253.2995124948098)
  );
  background-repeat: no-repeat;
}
.oxy {
  background: linear-gradient(
    to right,
    rgb(63.83205110993896, 5.2179051169453095, 5.0155733864456735),
    rgb(111.32004242653103, 5.841714242012307, 15.039668320441022),
    rgb(84.12184431862899, 83.6159948370921, 83.24632836662654),
    rgb(111.32407968833061, 110.83967630062348, 110.31677759973934),
    rgb(139.04447272646766, 138.60970836936644, 137.92453100777908),
    rgb(170.37022951393755, 170.00723021456022, 169.13465006028673),
    rgb(202.55492677766105, 202.26855332746777, 201.20168578285882),
    rgb(239.00788678127793, 238.79931636878882, 237.51259989085986),
    rgb(232.06917726555062, 220.00541348417778, 47.54943795870078),
    rgb(220.54668278037454, 174.92490197406946, 25.497038211532495)
  );
  background-repeat: no-repeat;
}
.deep {
  background: linear-gradient(
    to right,
    rgb(39.806003535935474, 26.165104409830633, 44.044000253923855),
    rgb(57.1664432237624, 46.808478140587226, 85.25750421350236),
    rgb(65.4343171186481, 69.00322669810848, 130.76307178326152),
    rgb(61.72638904987155, 99.85410287888797, 148.67654098306417),
    rgb(67.53724752325135, 128.01233134824838, 154.53107779964586),
    rgb(77.33638716275782, 156.9863458093556, 160.94703486180308),
    rgb(92.86831005836805, 185.56219978868532, 163.9537104022011),
    rgb(135.18132032821643, 212.29738331139853, 163.07612577336644),
    rgb(195.61297820889592, 232.86815622205665, 175.2889467196488),
    rgb(253.17348001728232, 253.56523110185535, 204.0347298651208)
  );
  background-repeat: no-repeat;
}
.dense {
  background: linear-gradient(
    to right,
    rgb(54.31090526102163, 14.252380046533654, 36.26342424013871),
    rgb(85.7989759802251, 22.06461261632537, 74.71224699302037),
    rgb(106.78660038324533, 39.527301944204844, 120.70452517708499),
    rgb(118.3516858026774, 66.46909065613033, 164.53566444075537),
    rgb(121.08270116842593, 96.73382662631964, 199.62555204425132),
    rgb(116.69179201518475, 131.0574687077482, 223.00246562883132),
    rgb(118.251357233103, 163.61740904027724, 228.53161034912037),
    rgb(143.18922717921836, 192.826268066118, 226.27953365660565),
    rgb(183.1351101917053, 217.60307997847204, 228.251696238598),
    rgb(230.06155183616042, 240.76584843683253, 240.66969638285332)
  );
  background-repeat: no-repeat;
}
.algae {
  background: linear-gradient(
    to right,
    rgb(17.55839067964479, 36.23281232955577, 20.153575203990844),
    rgb(24.637110317121774, 60.21077433538822, 38.839213813153435),
    rgb(25.373699104576946, 84.37542479416294, 55.08417304581284),
    rgb(17.57585421417838, 110.06839355576057, 68.68399952446144),
    rgb(6.858404623297841, 135.33528066459687, 77.4758059069887),
    rgb(43.71543297763709, 160.37315745497008, 81.80409909493339),
    rgb(100.03072435519584, 180.30072401548756, 98.87705874058494),
    rgb(143.14860909312404, 201.60342523575196, 131.32679811778968),
    rgb(179.7422477652839, 224.1757042885966, 167.77906099156073),
    rgb(214.94007726060866, 249.11277529871208, 207.73564072420987)
  );
  background-repeat: no-repeat;
}
.matter {
  background: linear-gradient(
    to right,
    rgb(47.21878677301089, 15.079039274757633, 61.97588197756816),
    rgb(83.3363402227638, 22.38457886644779, 84.09775748542634),
    rgb(120.99300654017593, 26.42178582117039, 97.35036482484378),
    rgb(158.84876795898214, 35.84349978858338, 98.45173065412862),
    rgb(191.82808630490047, 54.43149229532446, 91.06982430498441),
    rgb(218.95492047994702, 83.85484170029459, 82.91141058334337),
    rgb(234.7135564906137, 120.34714348232282, 88.2587138340288),
    rgb(244.06404077570824, 159.8677677283578, 109.90212753450986),
    rgb(249.71873574367936, 198.23140465727673, 139.9323685206129),
    rgb(253.54487181508566, 237.23358780741805, 176.22971007370938)
  );
  background-repeat: no-repeat;
}
.turbid {
  background: linear-gradient(
    to right,
    rgb(34.167993781172655, 30.526401043097934, 27.07913045813171),
    rgb(62.22904977078704, 48.424231940087736, 39.83677243701294),
    rgb(90.9839496856069, 65.11254931182745, 49.68400674367969),
    rgb(121.07926504142, 82.51771365514685, 55.973191075023216),
    rgb(148.59853329950755, 101.30165420068133, 58.32610254127212),
    rgb(173.0396540192162, 124.59457984482917, 60.910115253495334),
    rgb(191.1578384532829, 151.3253742294932, 71.10566865100417),
    rgb(205.17620337138018, 182.22663842399953, 96.18553688027787),
    rgb(217.97649093647135, 213.470277667311, 130.96838668231337),
    rgb(232.77031959624443, 245.79586371708592, 171.4489667987578)
  );
  background-repeat: no-repeat;
}
.speed {
  background: linear-gradient(
    to right,
    rgb(23.085854779154044, 35.021344934017755, 18.680691646361467),
    rgb(24.327812345704086, 61.565833231262836, 36.83896554113322),
    rgb(13.647865954773865, 88.27783168212805, 44.635699364795855),
    rgb(24.24752247273632, 114.52158266179418, 39.867559416789426),
    rgb(69.76026165623944, 136.30261432003994, 23.12573710584369),
    rgb(122.29360974357972, 155.0230816482595, 5.560439778611055),
    rgb(170.28102474708956, 171.94665898585257, 32.432573938237006),
    rgb(211.00982311640985, 192.61951487549229, 84.71308443305507),
    rgb(235.87247670955992, 220.13200282327384, 145.20086734070523),
    rgb(254.90445642601293, 252.79963626326676, 205.04581718375292)
  );
  background-repeat: no-repeat;
}
.amp {
  background: linear-gradient(
    to right,
    rgb(60.194372989476584, 9.000857386240273, 17.706547810502023),
    rgb(96.11790737208179, 14.340327327215716, 33.97432696933816),
    rgb(133.37827928627576, 14.242728545916016, 41.36940848895977),
    rgb(166.09935594519263, 34.4368747880717, 36.54482622104953),
    rgb(185.15698654301144, 70.41170596403225, 44.944897554171085),
    rgb(197.71359198343777, 106.19232177212118, 77.03135774922866),
    rgb(207.90988301756028, 138.50396812148622, 114.80370292553326),
    rgb(217.8181134232075, 171.5076480324349, 156.17450876506544),
    rgb(228.0179679624237, 203.8309705193407, 196.67085630151948),
    rgb(241.31850831785724, 236.8975842696571, 236.0670766338123)
  );
  background-repeat: no-repeat;
}
.tempo {
  background: linear-gradient(
    to right,
    rgb(20.975177818185685, 29.305724033046026, 67.52149278392186),
    rgb(26.534184307241947, 56.33616755394477, 83.22871183111204),
    rgb(27.834702708870225, 81.98048071693896, 99.47344318725588),
    rgb(20.837055319573878, 109.02936568602325, 114.54753246500141),
    rgb(22.478531273315777, 135.23815766321275, 124.46083684797733),
    rgb(71.47659552521036, 159.2841628666741, 130.47987200069983),
    rgb(125.40240240038942, 178.7341879813931, 143.75398616807968),
    rgb(174.00841013421186, 198.87480296458568, 169.6637540457679),
    rgb(215.78864578448477, 220.56670133315032, 203.92028260750473),
    rgb(254.63696406869227, 245.64061813707673, 244.23632342897335)
  );
  background-repeat: no-repeat;
}
.rain {
  background: linear-gradient(
    to right,
    rgb(33.550899829470936, 26.521417561333926, 56.44077356903427),
    rgb(37.17686118077636, 53.57004119279176, 77.27258614360846),
    rgb(26.38402964212206, 80.16729629985736, 98.50727263891169),
    rgb(3.5168645182826364, 107.45345621724091, 108.7558614552492),
    rgb(30.320571604469222, 131.91934557912862, 110.02678896904061),
    rgb(93.42933124288716, 151.22064324700736, 112.2177241224252),
    rgb(145.28835789813584, 167.08279573916332, 125.32956370194162),
    rgb(194.8387671765173, 183.38693071777502, 145.29307047636627),
    rgb(220.41552366135048, 207.29766503844803, 195.350752173558),
    rgb(238.32043006102657, 237.36594765274904, 242.94160075497095)
  );
  background-repeat: no-repeat;
}
.phase {
  background: linear-gradient(
    to right,
    rgb(167.86864018752402, 119.83448810303591, 12.60028492016953),
    rgb(202.8540440890336, 90.45612396900981, 59.83409913640899),
    rgb(221.9450490691268, 52.70336959140187, 123.20583928759594),
    rgb(207.87771952608514, 47.25145956735892, 208.4169581184993),
    rgb(160.30392381878647, 93.24306999081533, 243.5750014477597),
    rgb(87.62763726216158, 130.8664027951857, 223.41229220368172),
    rgb(30.04066871274612, 147.36764983742205, 167.72174313358624),
    rgb(15.127131777533364, 153.60763634595807, 107.20338530325428),
    rgb(104.24891254730414, 145.2881037965907, 25.131579066651234),
    rgb(167.86864018749915, 119.83448810304589, 12.60028492046341)
  );
  background-repeat: no-repeat;
}
.topo {
  background: linear-gradient(
    to right,
    rgb(39.806003535935474, 26.165104409830633, 44.044000253923855),
    rgb(65.4343171186481, 69.00322669810848, 130.76307178326152),
    rgb(67.2348251768625, 127.02359386643434, 154.30893940111628),
    rgb(92.86831005836805, 185.56219978868532, 163.9537104022011),
    rgb(193.48037229681188, 232.15601867502897, 174.51691907609046),
    rgb(25.838807657002214, 61.94800379950847, 27.968805823105935),
    rgb(86.38473137419588, 101.94864334279394, 52.9710890735624),
    rgb(164.28355371082122, 138.25515576636386, 63.4539532343566),
    rgb(213.24462348832242, 188.78460482719112, 128.77815179693087),
    rgb(248.57125042784426, 253.30474465633887, 228.20532503080892)
  );
  background-repeat: no-repeat;
}
.balance {
  background: linear-gradient(
    to right,
    rgb(60.194372989476584, 9.000857386240273, 17.706547810502023),
    rgb(133.521059860059, 14.257292579904288, 41.367764067463646),
    rgb(184.76274378656808, 69.39272944187744, 44.314674975191764),
    rgb(208.0253783484113, 138.88350633206133, 115.27063881892165),
    rgb(227.79866511715926, 203.18027859804522, 195.86806623855207),
    rgb(202.09046347568597, 211.67796465013467, 215.79300939620725),
    rgb(116.6168786913811, 169.5488339048715, 189.5755492095059),
    rgb(35.201019102092495, 121.60151326889931, 186.4890263058305),
    rgb(40.523725432054675, 65.94356329960742, 161.7511901844389),
    rgb(23.759956959295252, 28.349199016788695, 66.68565908102896)
  );
  background-repeat: no-repeat;
}
.delta {
  background: linear-gradient(
    to right,
    rgb(23.085854779154044, 35.021344934017755, 18.680691646361467),
    rgb(13.600071021140932, 88.38121098545308, 44.642270979443765),
    rgb(68.3561081740958, 135.7530243404567, 23.713407300877762),
    rgb(170.81864083630103, 172.1548670996092, 32.928979109136165),
    rgb(235.46875300641685, 219.5232956689137, 143.99336781491192),
    rgb(208.56213865469823, 224.36740673230415, 213.76382057849634),
    rgb(108.74870840686218, 181.56197500492246, 179.15079855093876),
    rgb(40.45090976519951, 129.63441534903117, 165.50114888808653),
    rgb(31.98827234528727, 72.78331478623741, 154.58611004799786),
    rgb(16.824233433518643, 31.584312734240594, 63.61769579267813)
  );
  background-repeat: no-repeat;
}
.curl {
  background: linear-gradient(
    to right,
    rgb(20.975177818185685, 29.305724033046026, 67.52149278392186),
    rgb(27.82530906500158, 82.08155573417052, 99.5355457957003),
    rgb(21.749639385149376, 134.52711532084146, 124.26741099452158),
    rgb(126.00066025041343, 178.95949215356308, 143.9861068151915),
    rgb(214.99269161345055, 220.10548852663592, 203.1728717071964),
    rgb(238.63643362765615, 210.79490987429654, 196.96240238319294),
    rgb(219.12469349785098, 140.7845925802209, 119.31312127179554),
    rgb(183.24532799263645, 73.56626378094228, 95.95957498761506),
    rgb(124.28381626003002, 27.868972829918953, 94.67988922952024),
    rgb(51.86706281603707, 13.070573977206095, 53.17698762616727)
  );
  background-repeat: no-repeat;
}
.diff {
  background: linear-gradient(
    to right,
    rgb(28.157358940674747, 34.14875008810586, 6.89504620731721),
    rgb(80.7743624318833, 75.12904472555562, 30.119952997241974),
    rgb(129.9161560087964, 116.7682042447814, 75.9934239456374),
    rgb(176.00547554790538, 166.45446858595537, 142.01580274303743),
    rgb(226.77400282229175, 220.72172384486478, 212.44127809044988),
    rgb(223.64013271818828, 223.6472915281929, 225.73208575307703),
    rgb(160.49920685251072, 171.40503971993715, 180.36215062286263),
    rgb(99.86314747643274, 124.16451576806283, 141.22982698515193),
    rgb(40.25199796691063, 81.86577420643941, 109.170531126018),
    rgb(7.85442132403282, 34.896419521677664, 63.71084336277833)
  );
  background-repeat: no-repeat;
}
.tarn {
  background: linear-gradient(
    to right,
    rgb(22.904929948713956, 35.365547163445875, 13.616068606232362),
    rgb(68.43144265394346, 80.25581463814989, 16.01951974518775),
    rgb(145.90816188763523, 110.82524280251539, 41.180140297795944),
    rgb(211.3489975052571, 151.85873716359907, 103.67131412648514),
    rgb(238.50935644044657, 217.08853796484487, 201.48432954748853),
    rgb(231.0567675690014, 223.46341380804148, 201.58109863822273),
    rgb(150.50068578705492, 177.56785124965947, 152.25103534006794),
    rgb(61.347944531984204, 134.13214773723672, 128.4679512799909),
    rgb(23.502605469940665, 84.35399837916037, 108.17675484925958),
    rgb(15.688279723124817, 30.158096721367595, 79.27424531458526)
  );
  background-repeat: no-repeat;
}
</style>
